import React from "react";

interface StaffLocationTabChangeLocationModalHeaderProps {
  allowEnterManually?: boolean;
  enteringManually?: boolean;
  onReturnToLocationSearch?: () => void;
}
export default function StaffLocationTabChangeLocationModalHeader({
  allowEnterManually,
  enteringManually,
  onReturnToLocationSearch,
}: StaffLocationTabChangeLocationModalHeaderProps) {
  if (allowEnterManually && enteringManually) {
    return (
      <div>
        Enter Manually
        <div className='tw-text-base tw-font-normal'>
          <button
            onClick={onReturnToLocationSearch}
            className='tw-mb-0 tw-border-none tw-bg-transparent tw-px-0 tw-pt-2 tw-text-blue hover:tw-cursor-pointer hover:tw-underline'
          >
            Return To Location Search
          </button>
        </div>
      </div>
    );
  }

  return <>Change Location</>;
}
